import * as z from "zod/v4";

export const deleteWorkOrderStation = {
  name: "deleteWorkOrderStation" as const,
  input: z.object({ stationId: z.string() }),
  output: z.object({}),
};
